import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {VerticalVideoActionIconsProps} from './vertical-video-action-icons.types';
import styles from './vertical-video-action-icons.module.scss';

export function VerticalVideoActionIcons({iconNames}: VerticalVideoActionIconsProps): ReactElement {
  return (
    <>
      {iconNames.map((iconName: string): ReactElement => {
        return <Icon ariaHidden className={styles.verticalVideoActionIcon} icon={iconName} key={iconName} size={IconSize.SIZE_ICON_16} />;
      })}
    </>
  );
}
